document.addEventListener("DOMContentLoaded", function () {
  var root = document.querySelector(".rkb");
  if (!root) return;

  var moneyFormat = root.dataset.moneyFormat || "${{amount}}";
  var currencyIso = root.dataset.currencyIso || "USD";
  var discountPct = parseFloat(root.dataset.discount || "20") || 20;
  var DISCOUNT = discountPct / 100;
  var noDecimalsIso = [
    "BIF", "CLP", "DJF", "GNF", "JPY", "KMF", "KRW", "MGA", "PYG", "RWF",
    "UGX", "VND", "VUV", "XAF", "XOF", "XPF",
  ];

  var state = { kb: null, acc: null };
  var kbFilter = "all";
  var accFilter = "all";

  function $(id) {
    return document.getElementById(id);
  }

  function formatMoney(cents, format) {
    if (typeof cents === "string") cents = cents.replace(/[^0-9]/g, "");
    cents = parseInt(cents, 10) || 0;
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision === undefined ? 2 : precision;
      thousands = thousands === undefined ? "," : thousands;
      decimal = decimal === undefined ? "." : decimal;
      if (isNaN(number) || number == null) return "0";
      if (noDecimalsIso.indexOf(currencyIso) !== -1) {
        number = (number * 1.0).toFixed(0);
      } else {
        number = (number / 100.0).toFixed(precision);
      }
      var parts = number.split(".");
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }

    var match = formatString.match(placeholderRegex);
    if (!match) return formatString;

    switch (match[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ", "");
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ",");
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  function money(cents) {
    return formatMoney(cents);
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }

  function getCard(slot, id) {
    return root.querySelector(
      '[data-slot="' + slot + '"][data-id="' + id + '"]'
    );
  }

  function readVariant(card) {
    var select = card.querySelector("[data-variant-select]");
    var single = card.querySelector(".rkb-single");
    if (select && select.tagName === "SELECT") {
      var opt = select.options[select.selectedIndex];
      return {
        id: opt.value,
        title: opt.textContent.trim(),
        price: parseInt(opt.dataset.price, 10) || 0,
        comparePrice: parseInt(opt.dataset.comparePrice, 10) || parseInt(opt.dataset.price, 10) || 0,
        priceText: opt.dataset.priceText || money(opt.dataset.price),
        comparePriceText: opt.dataset.comparePriceText || "",
        image: opt.dataset.image || "",
      };
    }
    return {
      id: single ? single.dataset.variantId : "",
      title: "",
      price: single ? parseInt(single.dataset.price, 10) || 0 : 0,
      comparePrice: single ? parseInt(single.dataset.price, 10) || 0 : 0,
      priceText: card.querySelector(".rkb-price-current")
        ? card.querySelector(".rkb-price-current").innerHTML
        : "",
      comparePriceText: "",
      image: "",
    };
  }

  function readProduct(card) {
    var v = readVariant(card);
    var imgEl = card.querySelector(".rkb-product-img, .rkb-img img");
    return {
      id: card.dataset.id,
      handle: card.dataset.handle,
      name: card.querySelector(".rkb-name").textContent.trim(),
      kind: card.dataset.kind || "",
      price: v.price,
      comparePrice: v.comparePrice,
      priceText: v.priceText,
      comparePriceText: v.comparePriceText,
      image: v.image || (imgEl ? imgEl.getAttribute("data-src") || imgEl.src : ""),
      variantId: v.id,
      variantTitle: v.title,
    };
  }

  function labelFor(slot, picked, hasOther) {
    if (picked) return "Remove from set";
    if (hasOther) return "Swap into set";
    return "Add to set";
  }

  function updateCardStates() {
    root.querySelectorAll("[data-slot]").forEach(function (card) {
      var slot = card.dataset.slot;
      var picked = state[slot] && state[slot].id === card.dataset.id;
      card.classList.toggle("is-picked", !!picked);
      var inset = card.querySelector(".rkb-inset");
      if (inset) inset.hidden = !picked;
      var btn = card.querySelector("[data-add]");
      if (btn && !btn.disabled) {
        btn.classList.toggle("is-picked", !!picked);
        btn.textContent = labelFor(slot, picked, !!state[slot]);
      }
    });
  }

  function applyFilters() {
    var kbCards = root.querySelectorAll('#rkb-kb-track [data-slot="kb"]');
    kbCards.forEach(function (card) {
      var show = kbFilter === "all" || card.dataset.filter === kbFilter;
      card.hidden = !show;
    });

    var accCards = root.querySelectorAll('#rkb-acc-track [data-slot="acc"]');
    var anyAcc = false;
    accCards.forEach(function (card) {
      var show = accFilter === "all" || card.dataset.filter === accFilter;
      card.hidden = !show;
      if (show) anyAcc = true;
    });

    var empty = root.querySelector("#rkb-acc-track .rkb-empty-filter");
    if (!anyAcc && accCards.length) {
      if (!empty) {
        empty = document.createElement("p");
        empty.className = "rkb-empty rkb-empty-filter";
        empty.textContent = "No items in this category yet.";
        $("rkb-acc-track").appendChild(empty);
      }
      empty.hidden = false;
    } else if (empty) {
      empty.hidden = true;
    }

    updateArrows();
  }

  function slotHTML(slot, justFilled) {
    var s = state[slot];
    if (!s) {
      return slot === "kb"
        ? '<button class="rkb-slot is-empty" type="button" data-goto="rkb-step-kb"><strong>Pick a keyboard</strong></button>'
        : '<button class="rkb-slot is-empty" type="button" data-goto="rkb-step-acc"><strong>Add a mouse or headset</strong></button>';
    }
    return (
      '<div class="rkb-slot is-filled' +
      (justFilled ? " just-filled" : "") +
      '">' +
      '<div class="rkb-thumb"><img src="' +
      esc(s.image) +
      '" alt=""></div>' +
      '<div class="rkb-slot-info">' +
      '<p class="rkb-slot-name">' +
      esc(s.name) +
      "</p>" +
      (s.variantTitle && s.variantTitle !== "Default Title"
        ? '<p class="rkb-slot-var">' + esc(s.variantTitle) + "</p>"
        : "") +
      '<div class="rkb-slot-row"><span class="rkb-slot-price">' +
      s.priceText +
      "</span>" +
      '<button class="rkb-remove" type="button" data-remove="' +
      slot +
      '">Remove</button></div>' +
      "</div></div>"
    );
  }

  function minPrice(slot) {
    var cards = root.querySelectorAll('[data-slot="' + slot + '"]');
    var min = Infinity;
    cards.forEach(function (card) {
      if (card.hidden) return;
      var p = readProduct(card);
      if (p.price < min) min = p.price;
    });
    return min === Infinity ? 0 : min;
  }

  function renderPanel(changed) {
    $("rkb-slot-kb").innerHTML = slotHTML("kb", changed === "kb");
    $("rkb-slot-acc").innerHTML = slotHTML("acc", changed === "acc");

    var kb = state.kb;
    var acc = state.acc;
    var both = !!(kb && acc);
    var sub = (kb ? kb.price : 0) + (acc ? acc.price : 0);
    var save = both ? Math.round(sub * DISCOUNT) : 0;
    var total = sub - save;

    $("rkb-num-kb") && $("rkb-num-kb").classList.toggle("is-done", !!kb);
    $("rkb-num-acc") && $("rkb-num-acc").classList.toggle("is-done", !!acc);
    $("rkb-plus").classList.toggle("is-on", both);
    $("rkb-m1").classList.toggle("on", !!(kb || acc));
    $("rkb-m2").classList.toggle("on", both);

    var status = $("rkb-status");
    var msg = "";
    if (both) {
      msg = discountPct + "% off unlocked. You save " + money(save) + ".";
    } else if (kb) {
      msg =
        "Add a mouse or headset to save at least " +
        money(Math.round((kb.price + minPrice("acc")) * DISCOUNT)) +
        ".";
    } else if (acc) {
      msg =
        "Add a keyboard to save at least " +
        money(Math.round((acc.price + minPrice("kb")) * DISCOUNT)) +
        ".";
    }
    status.innerHTML = msg;
    status.hidden = !msg;
    status.classList.toggle("is-win", both);

    $("rkb-sub").innerHTML = money(sub);
    $("rkb-save-row").hidden = !both;
    $("rkb-save").innerHTML = "−" + money(save);
    $("rkb-was").hidden = !both;
    $("rkb-was").innerHTML = money(sub);
    $("rkb-total").innerHTML = money(total);

    var cta = $("rkb-cta");
    var barCta = $("rkb-bar-cta");
    var label = both ? "Add set to cart" : "Add to cart";
    var enabled = !!(kb || acc);
    var variantIds = [kb && kb.variantId, acc && acc.variantId]
      .filter(Boolean)
      .join(",");

    if (cta) {
      if (enabled) {
        cta.removeAttribute("disabled");
        cta.setAttribute("data-variant-id", variantIds);
      } else {
        cta.setAttribute("disabled", "disabled");
        cta.setAttribute("data-variant-id", "");
      }
      var nameEl = cta.querySelector(".btn-name");
      if (nameEl) nameEl.textContent = label;
    }
    if (barCta) {
      barCta.disabled = !enabled;
      barCta.textContent = "Add to cart";
    }

    $("rkb-bs1").className = "rkb-bar-slot" + (kb ? " on" : "");
    $("rkb-bs1").innerHTML = kb
      ? '<img src="' + esc(kb.image) + '" alt="">'
      : "1";
    $("rkb-bs2").className = "rkb-bar-slot" + (acc ? " on" : "");
    $("rkb-bs2").innerHTML = acc
      ? '<img src="' + esc(acc.image) + '" alt="">'
      : "2";
    $("rkb-bar-total").innerHTML = money(total);
    var hint = $("rkb-bar-hint");
    hint.innerHTML = both
      ? "Saved " + money(save)
      : "Add 2, save " + discountPct + "%";
    hint.classList.toggle("win", both);

    updateCardStates();
  }

  var toastTimer;
  function toast(text, action, target) {
    var t = $("rkb-toast");
    var b = $("rkb-toast-btn");
    $("rkb-toast-text").textContent = text;
    b.hidden = !action;
    if (action) {
      b.textContent = action;
      b.onclick = function () {
        goTo(target);
        t.classList.remove("show");
      };
    }
    t.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      t.classList.remove("show");
    }, 4000);
  }

  function goTo(id) {
    var el = $(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  root.addEventListener("click", function (e) {
    var add = e.target.closest("[data-add]");
    if (add && !add.disabled) {
      e.preventDefault();
      var card = add.closest("[data-slot]");
      if (!card) return;
      var slot = card.dataset.slot;
      var id = card.dataset.id;
      if (state[slot] && state[slot].id === id) {
        state[slot] = null;
        renderPanel();
        return;
      }
      state[slot] = readProduct(card);
      renderPanel(slot);
      if (slot === "kb" && !state.acc) {
        toast(
          "Keyboard added. Next, add a mouse or headset.",
          "Go to step 2",
          "rkb-step-acc"
        );
      } else if (slot === "acc" && !state.kb) {
        toast(
          "Added. Now choose a keyboard to unlock " + discountPct + "% off.",
          "Go to step 1",
          "rkb-step-kb"
        );
      } else if (state.kb && state.acc) {
        toast("Set complete. " + discountPct + "% off unlocked.");
      }
      return;
    }

    var rm = e.target.closest("[data-remove]");
    if (rm) {
      state[rm.getAttribute("data-remove")] = null;
      renderPanel();
      return;
    }

    var go = e.target.closest("[data-goto]");
    if (go) {
      goTo(go.getAttribute("data-goto"));
      return;
    }

    var chip = e.target.closest(".rkb-chip");
    if (chip) {
      var group = chip.parentNode;
      group.querySelectorAll(".rkb-chip").forEach(function (c) {
        c.setAttribute("aria-pressed", c === chip ? "true" : "false");
      });
      if (group.id === "rkb-kb-filters") {
        kbFilter = chip.getAttribute("data-filter");
        $("rkb-kb-track").scrollLeft = 0;
      } else {
        accFilter = chip.getAttribute("data-filter");
        $("rkb-acc-track").scrollLeft = 0;
      }
      applyFilters();
    }
  });

  root.addEventListener("change", function (e) {
    var sel = e.target.closest("[data-variant-select]");
    if (!sel) return;
    var card = sel.closest("[data-slot]");
    if (!card) return;
    var opt = sel.options[sel.selectedIndex];
    var priceEl = card.querySelector(".rkb-price-current");
    if (priceEl) {
      priceEl.innerHTML = opt.dataset.priceText;
      priceEl.dataset.price = opt.dataset.price;
    }
    var compareEl = card.querySelector(".rkb-price-compare");
    if (opt.dataset.comparePriceText) {
      if (compareEl) {
        compareEl.innerHTML = opt.dataset.comparePriceText;
        compareEl.hidden = false;
      } else {
        var priceWrap = card.querySelector(".rkb-price");
        compareEl = document.createElement("s");
        compareEl.className = "rkb-price-compare";
        compareEl.innerHTML = opt.dataset.comparePriceText;
        priceWrap.appendChild(compareEl);
      }
    } else if (compareEl) {
      compareEl.hidden = true;
    }
    var img = card.querySelector(".rkb-product-img, .rkb-img img");
    if (img && opt.dataset.image) {
      img.src = opt.dataset.image;
      if (img.hasAttribute("data-src")) img.setAttribute("data-src", opt.dataset.image);
    }
    var slot = card.dataset.slot;
    if (state[slot] && state[slot].id === card.dataset.id) {
      state[slot] = readProduct(card);
      renderPanel();
    }
  });

  var CAROUSELS = [
    ["rkb-kb-track", "rkb-prev", "rkb-next", false],
    ["rkb-acc-track", "rkb-acc-prev", "rkb-acc-next", true],
  ];

  function updateArrows() {
    CAROUSELS.forEach(function (c) {
      var t = $(c[0]);
      if (!t) return;
      var fits = t.scrollWidth <= t.clientWidth + 2;
      var prev = $(c[1]);
      var next = $(c[2]);
      if (prev && next) {
        prev.hidden = next.hidden = c[3] && fits;
        prev.disabled = t.scrollLeft <= 2;
        next.disabled = t.scrollLeft + t.clientWidth >= t.scrollWidth - 2;
      }
    });
  }

  CAROUSELS.forEach(function (c) {
    var t = $(c[0]);
    if (t) {
      t.addEventListener("scroll", function () {
        window.requestAnimationFrame(updateArrows);
      });
    }
  });

  root.addEventListener("click", function (e) {
    var a = e.target.closest("[data-scroll]");
    if (!a) return;
    var t = $(a.getAttribute("data-scroll"));
    if (!t) return;
    t.scrollBy({
      left: t.clientWidth * +a.getAttribute("data-dir"),
      behavior: "smooth",
    });
  });

  window.addEventListener("resize", updateArrows);

  var barSlots = $("rkb-bar-slots");
  if (barSlots) {
    barSlots.addEventListener("click", function () {
      goTo("rkb-panel");
    });
  }

  if ("IntersectionObserver" in window && $("rkb-panel") && $("rkb-bar")) {
    new IntersectionObserver(
      function (entries) {
        $("rkb-bar").classList.toggle("is-off", entries[0].isIntersecting);
      },
      { threshold: 0.15 }
    ).observe($("rkb-panel"));
  }

  var barCtaBtn = $("rkb-bar-cta");
  if (barCtaBtn) {
    barCtaBtn.addEventListener("click", function () {
      var cta = $("rkb-cta");
      if (cta && !cta.hasAttribute("disabled")) cta.click();
    });
  }

  applyFilters();
  renderPanel();
});
